import { useCallback, useEffect, useState } from "react";
import {
  fetchPreEpChecklist,
  PreEpChecklist,
} from "../api/fetchPreEpChecklist";
import {
  PreEpExternalItem,
  updatePreEpChecklistItem,
} from "../api/updatePreEpChecklistItem";

const DONE_FIELD: Record<
  PreEpExternalItem,
  "cultureIndexDone" | "activationCourseDone"
> = {
  "culture-index": "cultureIndexDone",
  "activation-course": "activationCourseDone",
};

/** The member's Pre-EP checklist, and marking the outside-site steps done. */
export const usePreEpChecklist = () => {
  const [checklist, setChecklist] = useState<PreEpChecklist | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPreEpChecklist()
      .then((response) => setChecklist(response.data))
      .finally(() => setLoading(false));
  }, []);

  /** Opening the step's link counts as doing it: done right away, saved per person. */
  const markExternalDone = useCallback((item: PreEpExternalItem) => {
    setChecklist((current) =>
      current ? { ...current, [DONE_FIELD[item]]: true } : current,
    );
    void updatePreEpChecklistItem({ item, done: true }).then((response) =>
      setChecklist(response.data),
    );
  }, []);

  return { checklist, loading, markExternalDone };
};
